// => Import React
import React, { useEffect, useRef } from "react";

//=> Import plugins
import Markdown from "markdown-to-jsx";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Helmet } from "react-helmet";
import { convertDate } from "../../utils/convertDate";
import { MdAccessTimeFilled } from "react-icons/md";
import { GiSandsOfTime } from "react-icons/gi";
import { GrFormClose } from "react-icons/gr";


//=> Import container
import {
  modal,
  eventContainer,
  title,
  image,
  whenWhere,
  whenWhereContent,
  whenWhereTitle,
  titleAtelier,
  descriptionEvent,
  close,
  body,
} from "./styles.module.scss";

//=> Component
const ListModal = ({
  closeModal,
  date,
  description,
  done,
  feedback,
  image: {
    alternativeText,
    file: { url },
  },
  name,
  time,
}) => {
  // close Modal
  const handlerOnClickModal = (evt) => {
    const close = evt.target.closest("#close") ? true : false;
    if (evt.target.id === "modal" || close) {
      closeModal();
    }
  };

  const handlerOnKeyDown = (e) => {
    if (e.keyCode === 13 || e.keyCode === 27) {
      closeModal();
    }
  }

  // Get Date =>
  const [day, dayMonth, month, year, hours, minutes] = convertDate(date);

  // Donne le focus sur la modal quand elle s'ouvre 
  const modalElem = useRef(null)
  useEffect(() => {
    modalElem.current.focus()
  }, []);

  // Return =>
  return (
    <div
      ref={modalElem}
      className={modal}
      id="modal"
      role="dialog"
      aria-labelledby="dialog-title"
      aria-describedby="dialog-desc"
      aria-modal="true"
      aria-hidden="true"
      tabIndex="-1"
      onClick={handlerOnClickModal}
      onKeyDown={(e) => { handlerOnKeyDown(e) }}
    >
      {/* Permet de styliser le body à partir d'un enfant */}
      <Helmet>
        <body className={body} />
      </Helmet>
      <div className={eventContainer}>
        <div className={close} id="close" onClick={handlerOnClickModal} onKeyDown={(e) => { handlerOnKeyDown(e) }} tabIndex={0}>
          <GrFormClose size="1.7em" />
        </div>
        <h4 className={title}>{name}</h4>
        <div
          className={image}
          style={{ backgroundImage: `url(${url})` }}
          title={alternativeText}
          aria-label={alternativeText}
        />
        <div className={descriptionEvent}>
          <Markdown children={description} />
        </div>

        <div className={whenWhere}>
          <div className={whenWhereContent}>
            <div className={whenWhereTitle}>
              <MdAccessTimeFilled
                style={{ transform: "translate(-10px, 2px)" }}
              />
              Quand
            </div>
            <div>{`${day} ${dayMonth} ${month} ${year} `}</div>
            <div>{`${hours}h${minutes}`}</div>
          </div>
          <div className={whenWhereContent}>
            <div className={whenWhereTitle}>
              {" "}
              <GiSandsOfTime
                style={{ transform: "translate(-5px, 2px)" }}
              />{" "}
              Durée
            </div>
            <div>{time}h</div>
          </div>
        </div>
        {/* Map */}
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2907.845170661475!2d2.34784881616829!3d43.21273668881714!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12ae2c373b782f6d%3A0xe10be9e8c97dcf97!2s72%20Rue%20de%20Verdun%2C%2011000%20Carcassonne!5e0!3m2!1sfr!2sfr!4v1643986394916!5m2!1sfr!2sfr"
          height="450"
          style={{ border: 0, width: "100%" }}
          loading="lazy"
        ></iframe>

        {done && (
          <>
            <h4 className={titleAtelier}>Quelque photos de l'atelier</h4>
            {
              <Carousel
                showIndicators={false}
                showStatus={false}
                showArrows={true}
                dynamicHeight={true}
              >
                {feedback.map((imageData) => (
                  <div>
                    <img
                      src={imageData.file.url}
                      alt={imageData.alternaticeText}
                    />
                  </div>
                ))}
              </Carousel>
            }
          </>
        )}
      </div>
    </div>
  );
};

export default ListModal;
